import { render, staticRenderFns } from "./ShortcutsManager.vue?vue&type=template&id=12ae50f8&"
import script from "./ShortcutsManager.vue?vue&type=script&lang=js&"
export * from "./ShortcutsManager.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutsManager.vue?vue&type=style&index=0&id=12ae50f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports